import styles from './GameCard.module.css';

export const GameCard = ({ game }) => {
  return (<a href={game.route} className={styles.container}>
    {game.name}
  </a>)
}